import DOMHelpers from '../utils/dom-helpers';
import { gsap } from 'gsap';
import Cookies from 'js-cookie';

export default class gdprBar{

    constructor(options) {

        this.defaults = {
        	main 			: undefined,
        	el   			: undefined, // DOM element
        	debug 			: false,

			

        	// https://geolocation-db.com
        	// api key to registered user filippo@forofficeuseonly.com
        	geolocation_url	: 'https://geolocation-db.com/jsonp/7733a990-ebd4-11ea-b9a6-2955706ddbf3', //6db070f0-7c27-11ea-8264-e974339fc182',
	    	eu_country_codes : [
				'AT', // - Austria
				'BE', // - Belgium
				'BG', // - Bulgaria
				'CY', // - Cyprus
				'CZ', // - Czech Republic
				'DE', // - Germany
				'DK', // - Denmark
				'EE', // - Estonia
				'ES', // - Spain
				'FI', // - Finland
				'FR', // - France
				'GR', // - Greece 
				'HR', // - Croatia
				'HU', // - Hungary
				'IE', // - Ireland
				'IT', // - Italy
				'LT', // - Lithuania
				'LU', // - Luxembourg
				'LV', // - Latvia
				'MT', // - Malta
				'NL', // - Netherlands
				'PO', // - Poland
				'PT', // - Portugal
				'RO', // - Romania
				'SE', // - Sweden
				'SI', // - Slovenia
				'SK'  // - Slovakia
			],

			retry: 3 // times to retry if some error occurs
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace 		= 'gdpr-bar';
		this.main			= this.options.main;
		this.el 			= this.options.el;
		this.index_retry	= 0;
		this.cookie 		= 'fondation-trahan-gdpr-bar'; 
		
		this.dom = new DOMHelpers(document);

		this.options.debug = location.hostname !== 'fondationtrahan.org';

		//console.log( this.el );
		if ( document.body.classList.contains( 'home' ) && ! document.documentElement.classList.contains( 'end-logo-anim' ) ){
			return;
		}
		this.init( 777 );
    }

    init( delay=0 ){
		
		if ( this.options.debug ){
			this.activateGDPR();
		}
		else{
			setTimeout(()=>this.initGeoIp(), delay );
		}

    }

    activateGDPR(){
		if ( !Cookies ) {
			return;
		}
		//console.log( Cookies.get( this.cookie ) !== "active" );
		// Check cookie 
		if ( Cookies.get( this.cookie ) !== "active" ) {
			this.addEvents( true );
			// show bar
			this.dom.addClass( this.el,  'active' );
		}
		else{
			this.remove();
		}
		
    }

	addEvents (b){
		if ( b ){
			this.dom.on( this.el.querySelector( '.close' ), 'click', this.onCloseWin );
		}
		else{
			this.dom.off( this.el.querySelector( '.close' ), 'click', this.onCloseWin );
		}
	}

	onCloseWin = (e) => {
		e.preventDefault();
		Cookies.set( this.cookie , 'active', { expires: 90 }); // cookie will expire in 90 day
		// hide bar
		gsap.to( this.el, { duration:0.4, opacity:0, bottom:0, ease: 'Linear.easeOut', onComplete:()=>this.remove()})
	}

    initGeoIp(){
    	// https://geolocation-db.com 
		this.fetchJsonpData( this.options.geolocation_url );   	
    }

	fetchJsonpData(url) {
        const script = document.createElement('script');
        const callbackName = 'callback'; // Must match the function name defined above

		window.callback = (data) => {
			//console.log('JSONP Data:', data);
			//console.log( this );
			this.response(data);

			delete window.callback;
		}

        // Append the callback parameter to the URL
        script.src = `${url}?callback=${callbackName}`;

        // Handle script loading errors (optional)
        script.onerror = () => {
            console.error("Error loading JSONP script.");
            // Clean up the script tag if there's an error
            document.head.removeChild(script);

			this.error();
        };

        // Append the script to the document head to initiate the request
        document.head.appendChild(script);

        // Optionally, remove the script tag after it's loaded to keep the DOM clean
        script.onload = function() {
            document.head.removeChild(script);
        };
    }

    response( response ){
      	//console.log('GDPR: User\'s Location Data is ', response );
		if ( this.validateResponse( response ) ){
      		this.activateGDPR();
      	}
      	else{
      		this.remove();
      	}
    }

	validateResponse( response ){
		if ( this.options.eu_country_codes.includes( response.country_code ) ){
			return true;
		}
		if ( response.country_code === 'US' && response.state === 'California' ){ // California
			return true;
		}
		return false;
	}

	error(){ //data, status ){
      	// console.log('GDPR: Request failed.  Returned status of: ', status );
      	this.index_retry++;
      	if ( this.index_retry <= this.options.retry ){
      		this.init( 377 );
      		return;
      	}
      	this.activateGDPR();
    }

    remove(){
		this.addEvents( false );
    	this.el.remove();
    }

}



